"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var CPPCodeBlock_1 = require("./CPPCodeBlock");
var CPPFormatter_1 = require("./CPPFormatter");

var CPPFunction = function () {
    function CPPFunction(returnType, functionName) {
        var parameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        _classCallCheck(this, CPPFunction);

        this.returnType = returnType;
        this.functionName = functionName;
        this.parameters = parameters;
        this.body = [];
        this.virtual = false;
        this.pureVirtual = false;
    }

    _createClass(CPPFunction, [{
        key: "getSignature",
        value: function getSignature() {
            var getAsDefinition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var output = this.returnType + ' ';
            if (!getAsDefinition && this.parentClass != null) {
                output += this.parentClass.getClassName() + "::";
            }
            var args = [];
            var fmtr = new CPPFormatter_1.default();
            this.parameters.forEach(function (variable) {
                var param = variable.write(fmtr);
                args.push(param.slice(0, -1));
            });
            output += this.functionName + "(" + args.join(', ') + ")";
            if (this.pureVirtual && getAsDefinition) {
                output += ' = 0';
            }
            if (getAsDefinition) {
                output += ';';
            }
            return output;
        }
    }, {
        key: "implementFunction",
        value: function implementFunction(body) {
            this.body = body;
        }
    }, {
        key: "appendFunction",
        value: function appendFunction(body) {
            if (body instanceof Array) {
                this.body = this.body.concat(body);
            } else {
                this.body.push(body);
            }
        }
    }, {
        key: "getParentClass",
        value: function getParentClass() {
            return this.parentClass || null;
        }
    }, {
        key: "setParentClass",
        value: function setParentClass(parentClass, visibility) {
            parentClass.setMethod(this, visibility, this.virtual);
            this.parentClass = parentClass;
            return this;
        }
    }, {
        key: "getVirtual",
        value: function getVirtual() {
            return this.virtual;
        }
    }, {
        key: "setVirtual",
        value: function setVirtual(virtual) {
            this.virtual = virtual;
            return this;
        }
    }, {
        key: "getPureVirtual",
        value: function getPureVirtual() {
            return this.pureVirtual;
        }
    }, {
        key: "setPureVirtual",
        value: function setPureVirtual(pure) {
            this.pureVirtual = pure;
            if (pure) {
                this.virtual = true;
            }
            return this;
        }
    }, {
        key: "write",
        value: function write(formatter) {
            var indentCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var block = new CPPCodeBlock_1.default(this.getSignature(), this.body);
            return block.write(formatter, indentCount);
        }
    }]);

    return CPPFunction;
}();

exports.default = CPPFunction;